import forge from 'node-forge';

// generate deterministic guid from string
export const deterministicGuid = (source) => {
  const hash = forge.md.sha1.create().update(source).digest().toHex();
  const guid = `${hash.substr(0, 8)}-${hash.substr(8, 4)}-${hash.substr(12, 4)}-${hash.substr(16, 4)}-${hash.substr(
    20,
    12,
  )}`;
  return guid.toUpperCase();
};

export default deterministicGuid;
